import React, { useState, useEffect, useRef } from "react";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { Toasts } from "../toasts";
import useTable from "../useTableServerSide";
import axios from "axios";
import { ActualizarFicha } from "./modalRegistrarFicha";
import { SearchInput } from "@/ui/inputs/Input";
import { PrimaryButton } from "@/ui/buttons/Button";

function TablaFicha(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("@/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [credito, setCredito] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [operacion, setOperacion] = useState();
  const [inmueble, setInmueble] = useState();
  const permiso = JSON.parse(localStorage.getItem("accfichacat"));

  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  // ESTADOS PARA MANEJAR LA TABLA DESDE EL BACKEND
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  // ESTADO SEPARADO PARA EL INPUT DE BÚSQUEDA
  const [searchInput, setSearchInput] = useState("");

  // REF PARA ALMACENAR EL TIMEOUT DEL DEBOUNCE
  const searchTimeoutRef = useRef(null);

  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    orderBy: "idinmueble",
    orderDir: "desc",
    search: "",
  });

  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "N° FICHA",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRE PROPIETARIO",
      disableSorting: false,
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "DIRECCION",
      disableSorting: false,
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "codigocatastral",
      label: "CODIGO CATASTRAL",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cedulapropie",
      label: "CEDULA",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      disableSorting: true,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  // CALLBACKS QUE ESCUCHAN LOS CAMBIOS DEL HOOK useTable
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTable(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  // FUNCIÓN DE BÚSQUEDA CON DEBOUNCE
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    // Limpiar el timeout anterior si existe
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Si está vacío, limpiar la búsqueda inmediatamente
    if (value.length === 0) {
      setTableState((prev) => ({ ...prev, search: "", page: 0 }));
      return;
    }

    // Si tiene menos de 3 caracteres, no buscar
    if (value.length < 3) {
      return;
    }

    // Esperar 500ms después de la última tecla para buscar
    searchTimeoutRef.current = setTimeout(() => {
      setTableState((prev) => ({
        ...prev,
        search: value,
        page: 0,
      }));
    }, 500);
  };

  // LIMPIAR TIMEOUT AL DESMONTAR EL COMPONENTE
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // PETICIÓN AL BACKEND CON PARÁMETROS DE PAGINACIÓN
  const seleccionarRegistrosInmueble = () => {
    setActivate(true);

    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      orderBy: tableState.orderBy,
      orderDir: tableState.orderDir,
      search: tableState.search,
    };

    let endpoint = op.conexion + `/api/catalogo/inmueblesPaginacion`;

    // AbortController para cancelar peticiones anteriores
    const controller = new AbortController();

    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch(function (error) {
        // No mostrar error si la petición fue cancelada intencionalmente
        if (axios.isCancel(error)) {
          console.log("Petición cancelada por nueva búsqueda");
          return;
        }
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });

    // Retornar función para abortar la petición
    return () => controller.abort();
  };

  // SE EJECUTA CADA VEZ QUE CAMBIA EL ESTADO DE LA TABLA
  useEffect(() => {
    const cleanup = seleccionarRegistrosInmueble();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);

  const SelectDeudaC = (data) => {
    let endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${data.idinmueble}&fecha=${fechaSistema}&espiritu=${espiritu}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200 && response.data) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace(/'/g, ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace(/'/g, ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
          setMostrar(true);
        } else {
          setMostrar(true);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || "Error en la deuda",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idinmueble) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200 && response.data) {
          if (response.data !== "") {
            setInmueble(response.data);
            setCredito(response.data.credito);
            SelectDeudaC(response.data);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message || "Error al seleccionar registro",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarInmueble = (op, id, per) => (e) => {
    e.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op !== 1) {
        seleccionarRegistro(id);
      } else {
        setMostrar(true);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
              ? "No posee permiso para Editar"
              : op === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  return (
    <div
      className="col-8 m-0 p-2 rounded d-flex flex-column justify-content-center"
      style={{ minHeight: "80vh" }}
    >
      <div className="col-12 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light azulGradiant rounded-top">
          <h3 className="fw-bold m-0">Gestion de Fichas Catastrales</h3>
        </header>

        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
          <div className="col-4 m-0 p-0 position-relative">
            <SearchInput
              className="search-input pe-4"
              value={searchInput}
              onChange={handleSearch}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              icon="fa-plus m-0"
              onClick={(e) =>
                seleccionarInmueble(
                  1,
                  "",
                  permiso.toString().substring(1, 2),
                )(e)
              }
              disabled={permiso.toString().substring(1, 2) !== "1"}
              title="Agregar Contribuyente"
            />
          </div>
        </div>

        <section className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.map((item) => (
                  <tr key={item.idinmueble} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idinmueble}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "80px",
                      }}
                    >
                      {item.numficha}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "250px",
                      }}
                    >
                      {item.nombrepropie}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "250px",
                      }}
                    >
                      {item.dirinmueble}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      {item.codigocatastral}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "100px",
                      }}
                    >
                      {item.cedulapropie}
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center gap-2 p-2">
                        <button
                          onClick={seleccionarInmueble(
                            4,
                            item.idinmueble,
                            permiso.toString().substring(0, 1),
                          )}
                          title="Consultar Contribuyente"
                          className={
                            permiso.toString().substring(0, 1) === "1"
                              ? "btn btn-sm btn-info rounded-pill"
                              : "btn btn-sm btn-secondary rounded-pill"
                          }
                        >
                          <i className="fas fa-eye"></i>
                        </button>
                        <button
                          onClick={seleccionarInmueble(
                            2,
                            item.idinmueble,
                            permiso.toString().substring(2, 3),
                          )}
                          title="Editar Contribuyente"
                          className={
                            permiso.toString().substring(2, 3) === "1"
                              ? "btn btn-sm btn-warning rounded-pill"
                              : "btn btn-sm btn-secondary rounded-pill"
                          }
                        >
                          <i className="fa fa-edit"></i>
                        </button>
                        <button
                          onClick={seleccionarInmueble(
                            3,
                            item.idinmueble,
                            permiso.toString().substring(3, 4),
                          )}
                          title="Eliminar Contribuyente"
                          className={
                            permiso.toString().substring(3, 4) === "1"
                              ? "btn btn-sm btn-danger rounded-pill"
                              : "btn btn-sm btn-secondary rounded-pill"
                          }
                        >
                          <i className="fa fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </section>

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />

        <ActualizarFicha
          show={mostrar}
          onHideCancela={() => {
            setMostrar(false);
          }}
          operacion={operacion}
          inmueble={inmueble}
          onHideRender={seleccionarRegistrosInmueble}
          deuda={deuda}
          historico={historico}
          credito={credito}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />

        <Dimmer active={activate} inverted></Dimmer>
      </div>
    </div>
  );
}

export default TablaFicha;
